<div class="flex-direction-column gap-8 padding-15px">
  <span class="weight-600 font-14" style="margin-bottom: 11px">Editar Bloco</span>

  @if (selectedNodeEditando) {
    <app-form-field
      label="Título"
      heightFormField="35px"
      placeholder="Digite o título..."
      [value]="selectedNodeEditando.title"
      (changeValue)="selectedNodeEditando.title = $event; alteracaoService.camposAlterado()"
    ></app-form-field>

    <span class="label">Descrição</span>
    <textarea
      id="descricao"
      [(ngModel)]="selectedNodeEditando.description"
      (ngModelChange)="alteracaoService.camposAlterado()"
      rows="4"
      placeholder="Digite a descrição..."
    ></textarea>

    <app-select-one
      label="Tipo da Etapa"
      campo="label"
      widthFormField="100%"
      heightFormField="35px"
      [listaInput]="tipoEtapas"
      [itemSelecionado]="selectedNodeEditando.tipoEtapa"
      (selecionarItem)="selecionarTipo($event); alteracaoService.camposAlterado()"
      [disabled]="disabledTipoEtapa"
      [chaveCompare]="'value'"
    ></app-select-one>

    @if (!isRequisicao && !isOpcaoLista && !isCaptura && !isRequisicaoRetorno && !isDifyAgentAi) {
      <span class="label">{{ 'Mensagem Para Ser enviada' }}</span>
      <textarea
        id="mensagem"
        [(ngModel)]="selectedNodeEditando.content"
        (ngModelChange)="alteracaoService.camposAlterado()"
        (input)="textoAlterado()"
        rows="10"
        placeholder="Digite a mensagem..."
        [attr.maxlength]="isOpcaoLista ? 20 : null"
      ></textarea>
      @if (isTextoComVariavel) {
        <app-select-multiple
          [listaInput]="variaveisDoFluxoSelect"
          [itensSelecionado]="variaveisEnvioSelecionadas"
          [font]="'12px'"
          heightFormField="35px"
          campo="nome"
          (selecionarItem)="selecionarVariaveisEnvio($event)"
          colorLabel="black"
          label="Variáveis que serão enviadas!"
        ></app-select-multiple>
      }
    }
    @if (isOpcaoLista) {
      <app-form-field
        [max]="24"
        label="Título"
        heightFormField="35px"
        placeholder="Digite o título..."
        [value]="selectedNodeEditando.tituloOpcao"
        (changeValue)="selectedNodeEditando.tituloOpcao = $event; alteracaoService.camposAlterado()"
      ></app-form-field>
      @if (selectedNodeEditando.tituloOpcao && selectedNodeEditando.tituloOpcao.length > 23) {
        <div style="color: red; font-size: 0.9em">
          Titulo da opção pode ter no máximo 24 caracteres.
        </div>
      }
      <app-form-field
        [max]="24"
        label="Descrição"
        heightFormField="35px"
        placeholder="Digite a descrição..."
        [value]="selectedNodeEditando.descricaoOpcao"
        (changeValue)="selectedNodeEditando.descricaoOpcao = $event; alteracaoService.camposAlterado()"
      ></app-form-field>
      @if (selectedNodeEditando.descricaoOpcao && selectedNodeEditando.descricaoOpcao.length > 23) {
        <div style="color: red; font-size: 0.9em">
          Descrição da opção pode ter no máximo 24 caracteres.
        </div>
      }
    }

    @if (isAcao) {
      <app-select-one
        label="Ação a ser executada"
        campo="label"
        widthFormField="100%"
        heightFormField="35px"
        [listaInput]="acoes"
        [itemSelecionado]="selectedNodeEditando.acaoEtapa"
        (selecionarItem)="selecionarAcao($event); alteracaoService.camposAlterado()"
        [disabled]="disabledTipoEtapa"
        [chaveCompare]="'value'"
      ></app-select-one>
    }

    @if (isDifyAgentAi) {
      <app-select-one
          label="Método"
          placeholder="Selecione"
          widthFormField="100%"
          heightFormField="35px"
          [listaInput]="metodosAgente"
          campo="label"
          [chaveCompare]="'value'"
          [itemSelecionado]="metodoAgenteSelecionado"
          (selecionarItem)="selecionarMetodoAgente($event); alteracaoService.camposAlterado()"
      ></app-select-one>
      <app-form-field
          label="Url"
          placeholder="https://api.exemplo.com"
          heightFormField="35px"
          [font]="'12px'"
          [value]="selectedNodeEditando.agentAiDify!.url!"
          (changeValue)="selectedNodeEditando.agentAiDify!.url = $event; alteracaoService.camposAlterado()"
        ></app-form-field>
      <app-form-field
          label="Token"
          heightFormField="35px"
          [font]="'12px'"
          [value]="selectedNodeEditando.agentAiDify!.token!"
          (changeValue)="selectedNodeEditando.agentAiDify!.token = $event; alteracaoService.camposAlterado()"
      ></app-form-field>
      <app-form-field
          label="Response Mode"
          heightFormField="35px"
          [font]="'12px'"
          [value]="selectedNodeEditando.agentAiDify!.responseMode!"
          (changeValue)="selectedNodeEditando.agentAiDify!.responseMode = $event; alteracaoService.camposAlterado()"
      ></app-form-field>
      <app-form-field
          label="User"
          heightFormField="35px"
          [font]="'12px'"
          [value]="selectedNodeEditando.agentAiDify!.user!"
          (changeValue)="selectedNodeEditando.agentAiDify!.user = $event; alteracaoService.camposAlterado()"
      ></app-form-field>
      <app-select-one
          label="Variável (conversation_id)"
          placeholder="Selecione"
          heightFormField="35px"
          [font]="'12px'"
          [listaInput]="camposSelect"
          campo="nome"
          chaveCompare="id"
          [itemSelecionado]="conversationIdSelecionado"
          (selecionarItem)="selecionarConversationId($event);"
      ></app-select-one>
    }

    <span class="label">Fluxo em caso de erro:</span>

    @if (fluxoErroSelect.length > 0) {
      <app-select-one
        campo="nome"
        widthFormField="100%"
        heightFormField="35px"
        [desselecionar]="true"
        [listaInput]="fluxoErroSelect"
        [itemSelecionado]="selectedNodeEditando.fluxoErro"
        (selecionarItem)="selectedNodeEditando.fluxoErro = $event; alteracaoService.camposAlterado()"
      ></app-select-one>
    }
    @if (fluxoErroSelect.length < 1) {
      <div style="color: red; font-size: 0.9em">
        Sem fluxos de erro cadastrados.
      </div>
    }
    @if (isEntrada) {
      <app-select-one
        campo="nome"
        widthFormField="100%"
        label="Variável que irá receber"
        heightFormField="35px"
        [listaInput]="variaveisSelect"
        [itemSelecionado]="getVariavelSelecionada(selectedNodeEditando)"
        (selecionarItem)="selecionarVariavel($event, selectedNodeEditando)"
      ></app-select-one>
      <app-select-one
        campo="label"
        widthFormField="100%"
        label="Tipo de Validação da Variável"
        heightFormField="35px"
        [listaInput]="metodosValidadores"
        [itemSelecionado]="selectedNodeEditando.metodoValidador"
        (selecionarItem)="selecionarMetodoValidador($event.value); alteracaoService.camposAlterado()"
        [chaveCompare]="'value'"
      ></app-select-one>
    }
    @if (isRequisicao || isRequisicaoRetorno) {
      <app-form-requisicao
        [selectedNode]="selectedNodeEditando"
        [variaveisDoFluxoSelect]="variaveisDoFluxoSelect"
        [isRequisicaoRetorno]="isRequisicaoRetorno"
      ></app-form-requisicao>
    }
    @if (isCaptura) {
      <app-form-captura
        [selectedNode]="selectedNodeEditando"
        [variaveisSelect]="variaveisSelect"
        [fluxosSelect]="fluxosSelect"
      ></app-form-captura>
    }
    @if (selectedNodeEditando && isCanal) {
      <app-select-one
        label="Canais"
        campo="nome"
        heightFormField="35px"
        [listaInput]="canais"
        [itemSelecionado]="selectedNodeEditando.canal"
        (selecionarItem)="selectedNodeEditando.canal = $event; alteracaoService.camposAlterado()"
      ></app-select-one>
    }

    <app-form-field
      label="Possui Transbordo?"
      style="width: calc(50% - 5px)"
      [isCheckbox]="true"
      [value]="selectedNodeEditando.possuiTransbordo"
      (changeValue)="selectedNodeEditando.possuiTransbordo = $event; alteracaoService.camposAlterado()"
    ></app-form-field>

    @if (selectedNodeEditando.possuiTransbordo) {
      <app-select-one
        label="Fluxo de Transbordo"
        campo="nome"
        heightFormField="35px"
        [listaInput]="fluxosSelect"
        [itemSelecionado]="selectedNodeEditando.fluxoTransbordo"
        [chaveCompare]="'id'"
        (selecionarItem)="selectedNodeEditando.fluxoTransbordo = $event; alteracaoService.camposAlterado()"
      ></app-select-one>

      <app-form-field
        heightFormField="35px"
        label="Timer"
        type="time"
        [value]="selectedNodeEditando.timerTransbordo"
        (changeValue)="selectedNodeEditando.timerTransbordo = $event"
      ></app-form-field>
    }
  }

  <div class="flex-direction-column gap-5" style="margin-top: auto">
    <app-button-padrao
      width="100%"
      label="Salvar"
      backgroundColor="var(--verde-padrao)"
      color="white"
      (buttonClick)="salvarEdicao()"
    ></app-button-padrao>
    <app-button-padrao
      width="100%"
      label="Cancelar"
      backgroundColor="white"
      color="var(--vermelho-padrao)"
      (buttonClick)="cancelEdit()"
      borderColor="var(--vermelho-padrao)"
      borderStyle="solid"
      borderWidth="1px"
    ></app-button-padrao>
  </div>
</div>
